var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncBlue2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24998 3.3335V0.833496L3.91665 4.16683L7.24998 7.50016V5.00016C10.0083 5.00016 12.25 7.24183 12.25 10.0002C12.25 10.8418 12.0416 11.6418 11.6666 12.3335L12.8833 13.5502C13.5333 12.5252 13.9166 11.3085 13.9166 10.0002C13.9166 6.31683 10.9333 3.3335 7.24998 3.3335ZM7.24998 15.0002C4.49165 15.0002 2.24998 12.7585 2.24998 10.0002C2.24998 9.15849 2.45831 8.3585 2.83331 7.66683L1.61665 6.45016C0.966646 7.47516 0.583313 8.69183 0.583313 10.0002C0.583313 13.6835 3.56665 16.6668 7.24998 16.6668V19.1668L10.5833 15.8335L7.24998 12.5002V15.0002Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncBlue2);
export default __webpack_public_path__ + "static/media/sync-blue2.5a9c016fa3c407e90be1d827072d3bd0.svg";
export { ForwardRef as ReactComponent };